// extracted by mini-css-extract-plugin
export default {"field":"form_field__zD7-N","submitBtn":"form_submitBtn__sA5Sy","switchLink":"form_switchLink__k3AM7","errorMsg":"form_errorMsg__5B3Wx"};